/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions, IFilterService, ILogService} from 'angular';
import {rolePrefix, TSRole} from '../../../models/enums/TSRole';

import TSSchaden from '../../../models/TSSchaden';
import RoleUtilService from '../../service/RoleUtilService';
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

declare let require: any;
declare let angular: any;
let template = require('./dv-schaden-list.html');
require('./dv-schaden-list.scss');

export class DVSchadenListComponentConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        schaeden: '=',
        onEdit: '&',
        onDelete: '&',
        readonly: '<',
    };
    template = template;
    controller = DVSchadenListController;
    controllerAs = 'vm';
}

export class DVSchadenListController {

    itemsByPage: number;
    schaeden: Array<TSSchaden> = []; //Liste die im Gui angezeigt wird
    pagination: any;
    onEdit: (paramObj: any) => void;
    onDelete: (paramObj: any) => void;
    readonly: boolean;

    static $inject: any[] = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate'];
    /* @ngInject */
    constructor(private $filter: IFilterService, private $log: ILogService,
                private CONSTANTS: any, private $scope: IScope, private roleUtilService: RoleUtilService,
                private $window: IWindowService, private $translate: ITranslateService) {
        this.initViewModel();
    }

    private initViewModel() {

    }

    $onInit() {

    }

    public calcTotalSchaden(): number {
        let total = 0;
        if (this.schaeden !== undefined) {
            for (let obj of this.schaeden) {
                if (obj && obj.schadenDatenFS && obj.schadenDatenFS.geschaetzteKosten) {
                    total += obj.schadenDatenFS.geschaetzteKosten;
                }
            }
        }
        return total;
    }

    public getFilterroles(): Array<TSRole> {
        return this.roleUtilService.getAllRolesButGesuchstellerArray();

    }

    editClicked(schadenToEdit: any, event: any) {
        this.onEdit({schaden: schadenToEdit, event: event});
    }

    deleteClicked(schadenToDelete: any, event: any) {
        this.onDelete({schaden: schadenToDelete, event: event});
    }

    public translateAktiv(inaktiv: boolean): string {
        return inaktiv ? ( this.$translate.instant('INAKTIV')) : (this.$translate.instant('AKTIV'));

    }

    public translateRoles(roles: Array<TSRole>): string {
        let prefix = rolePrefix();
        return roles.map((element) => {
            return this.$translate.instant(prefix + TSRole[element])
        }).join(', ');

    }

    public translateRole(role: TSRole): string {
        let prefix = rolePrefix();
        return this.$translate.instant(prefix + TSRole[role])

    }

    public getColumnsNumber(): number {
        let element = angular.element('.dv-schaeden-list .header-row').first();
        if (element && element.get(0)) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 5;
    }


}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-schaden-list/dv-schaden-list.ts